import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.001 3.523a1.2 1.2 0 0 0-1.033.572l-1.01 1.687C11.324 6.844 10.142 7.5 8.86 7.5H6.862a1.2 1.2 0 0 0-1.033.573l-.792 1.325a1.1 1.1 0 0 0 .191 1.367l1.095 1.045a1.1 1.1 0 0 1 0 1.607 1.23 1.23 0 0 1-1.683 0l-1.094-1.045C2.407 11.285 2.172 9.605 2.97 8.27l.793-1.325c.636-1.062 1.818-1.718 3.1-1.718H8.86a1.2 1.2 0 0 0 1.033-.572l1.01-1.687C11.537 1.906 12.72 1.25 14 1.25H16c1.28 0 2.463.656 3.099 1.718l1.01 1.687a1.2 1.2 0 0 0 1.032.572h1.998c1.28 0 2.463.656 3.099 1.718l.793 1.325c.798 1.335.563 3.015-.576 4.102l-1.094 1.045a1.23 1.23 0 0 1-1.683 0 1.1 1.1 0 0 1 0-1.607l1.095-1.045c.38-.363.458-.923.192-1.367l-.793-1.325a1.2 1.2 0 0 0-1.033-.573H21.14c-1.28 0-2.463-.656-3.099-1.718l-1.01-1.687A1.2 1.2 0 0 0 16 3.523z",
      "clip-rule": "evenodd"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.438 10a.937.937 0 1 0-1.876 0v7.5c0 .173-.14.313-.312.313H10v-2.188A.625.625 0 0 0 9.375 15h-6.25a.625.625 0 0 0-.625.625v6.25c0 .345.28.625.625.625h6.25c.345 0 .625-.28.625-.625v-2.187h1.25c1.208 0 2.188-.98 2.188-2.188zm-9.063 6.875h3.75v3.75h-3.75zM16.563 10a.937.937 0 1 1 1.875 0v7.5c0 .173.14.313.312.313H20v-2.188c0-.345.28-.625.625-.625h6.25c.345 0 .625.28.625.625v6.25c0 .345-.28.625-.625.625h-6.25a.625.625 0 0 1-.625-.625v-2.187h-1.25a2.19 2.19 0 0 1-2.187-2.188zm5.312 6.875h3.75v3.75h-3.75z",
      "clip-rule": "evenodd"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.938 10a.937.937 0 1 0-1.876 0v11.25h-2.187a.625.625 0 0 0-.625.625v6.25c0 .345.28.625.625.625h6.25c.345 0 .625-.28.625-.625v-6.25a.625.625 0 0 0-.625-.625h-2.187zm-2.813 16.875v-3.75h3.75v3.75z",
      "clip-rule": "evenodd"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }